import { FC, useState, useRef, useEffect } from "react";
import styled from "styled-components";

const { NODE_ENV } = process.env;

const ContextSwitchContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 99999999999999999999;
`

const ContextSwitchButton = styled.button`
  padding: 6px 10px;
  background: white;
  border: 1px solid #ccc;
  cursor: pointer;
  min-width: 200px;
  text-align: left;
  font-size: 13px;
`

const DropdownContainer = styled.div<{ isOpen: boolean }>`
  display: ${props => props.isOpen ? 'flex' : 'none'};
  position: absolute;
  bottom: 100%;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px 16px 16px;
  gap: 16px;
  max-width: 800px;
  height: 600px;
  max-height: calc(100vh - 100px);
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 180px;
  max-width: 240px;
  overflow-y: auto;
  max-height: 600px;
  
  > div {
    margin-bottom: 16px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
    
    &:hover {
      background: #ccc;
    }
  }
`

const GroupLabel = styled.div`
  font-weight: 600;
  padding: 4px 8px;
  color: #666;
  font-size: 13px;
  position: sticky;
  top: 0;
  background: rgba(255, 255, 255, 0.98);
  border-bottom: 1px solid #eee;
  margin-bottom: 4px;
  z-index: 1;
`

const Option = styled.div<{ isSelected: boolean }>`
  padding: 4px 8px;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: ${props => props.isSelected ? '#f0f0f0' : 'transparent'};
  
  &:hover {
    background: ${props => props.isSelected ? '#e8e8e8' : '#f5f5f5'};
  }

  & + & {
    margin-top: 1px;
  }
`

interface Option {
  value: string;
  label: string;
}

interface Group {
  label: string;
  options: Option[];
}

interface Column {
  groups: Group[];
}

export const CONFIG: Column[] = [
  {
    groups: [
      {
        label: 'Main',
        options: [
          { value: '', label: '--default--' },
          { value: 'deziiign/main', label: 'deziiign.com' },
          { value: 'deziiign/hsedesign', label: 'hsedesign.ru' },
          { value: 'deziiign/mediiia', label: 'mediiia.com' },
          { value: 'deziiign/brnd', label: 'brnd.ru' },
          { value: 'deziiign/ageytomesh', label: 'ageytomesh.com' },
          { value: 'deziiign/superpuper', label: 'superpuper.games' },
        ]
      },
      {
        label: 'HSE',
        options: [
          { value: 'deziiign/hseanimation', label: 'hseanimation.ru' },
          { value: 'deziiign/hsecolors', label: 'hsecolors.com' },
          { value: 'deziiign/hsecreative', label: 'hsecreative.ru' },
          { value: 'deziiign/hsehh', label: 'hsehh.com' },
          { value: 'deziiign/online', label: 'hsedesign.online' },
          { value: 'deziiign/hsespace', label: 'hse.space' },
          { value: 'deziiign/hsestart', label: 'start.hsedesign.com' },
        ]
      }
    ]
  },
  {
    groups: [
      {
        label: 'LMS',
        options: [
          { value: 'deziiign/lmsmediiia', label: 'education.mediiia.com' },
          { value: 'deziiign/lmshse', label: 'lms.hsedesign.com' },
          { value: 'deziiign/lmshsecreative', label: 'lms.hsecreative.ru' },
        ]
      },
      {
        label: 'Mediiia',
        options: [
          { value: 'deziiign/automediiia', label: 'automediiia.com' },
          { value: 'deziiign/namesmediiia', label: 'names.mediiia.com' },
          { value: 'deziiign/naturemediiia', label: 'naturemediiia.com' },
          { value: 'deziiign/urbanmediiia', label: 'urban.deziiign.com' },
        ]
      },
      {
        label: 'Pro',
        options: [
          { value: 'deziiign/pro', label: 'pro.deziiign.com' },
          { value: 'deziiign/prohse', label: 'pro.hsedesign.com' },
        ]
      },
      {
        label: 'Geograffee',
        options: [
          { value: 'geograffee/academy', label: 'creativecity.academy' },
          { value: 'geograffee/dafes', label: 'dafes.net' },
          { value: 'geograffee/main', label: 'geograffee.com' },
        ]
      }
    ]
  },
  {
    groups: [
      {
        label: 'Competitions',
        options: [
          { value: 'deziiign/awards', label: 'awards.portfolio365.ru' },
          { value: 'deziiign/kiiids', label: 'family.kiiids.art' },
          { value: 'competition', label: 'competition.deziiign.com' },
          { value: 'deziiign/damuseum', label: 'contest.damuseum.ru' },
          { value: 'deziiign/greenaward', label: 'green-award.ru' },
        ]
      },
      {
        label: 'Books',
        options: [
          { value: 'deziiign/books', label: 'books.deziiign.com' },
          { value: 'deziiign/booksgallllery', label: 'books.gallllery.com' },
        ]
      },
      {
        label: 'Other',
        options: [
          { value: 'deziiign/monalisatravels', label: 'mona-lisa-travels.com' },
          { value: 'deziiign/alshibaya', label: 'alshibaya.com' },
          { value: 'deziiign/lab', label: 'lab.deziiign.com' },
          { value: 'deziiign/adcrdafesnet', label: 'adcr.dafes.net' },
          { value: 'deziiign/cgrave', label: 'cgrave.ru' },
          { value: 'deziiign/continuumsite', label: 'continuum.site' },
          { value: 'deziiign/school', label: 'designschool.am' },
          { value: 'deziiign/dvadesign', label: 'dva.design' },
          { value: 'deziiign/exams', label: 'exams2025.hsedesign.com' },
          { value: 'deziiign/fashion', label: 'fashion.deziiign.com' },
          { value: 'deziiign/galllleryart', label: 'gallllery.art' },
          { value: 'deziiign/game', label: 'game.deziiign.com' },
          { value: 'deziiign/iqmedia', label: 'iq-media.ru' },
          { value: 'deziiign/lpudesign', label: 'lpudesign.com' },
          { value: 'deziiign/onlines', label: 'onlinesdesign.com' },
        ]
      }
    ]
  }
];

const ContextSwitch: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(localStorage.getItem('current-app') || '');
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (NODE_ENV !== 'development') {
    return null;
  }

  const handleSelect = (value: string) => {
    setSelectedValue(value);
    setIsOpen(false);
    if (!value) {
      localStorage.removeItem('current-app');
    } else {
      localStorage.setItem('current-app', value);
    }
    window.location.reload();
  };

  return (
    <ContextSwitchContainer ref={containerRef}>
      <ContextSwitchButton onClick={() => setIsOpen(!isOpen)}>
        {selectedValue || '--default--'}
      </ContextSwitchButton>
      <DropdownContainer isOpen={isOpen}>
        {CONFIG.map((column, columnIndex) => (
          <Column key={columnIndex}>
            {column.groups.map(group => (
              <div key={group.label}>
                <GroupLabel>{group.label}</GroupLabel>
                {group.options.map(option => (
                  <Option
                    key={option.value}
                    isSelected={selectedValue === option.value}
                    onClick={() => handleSelect(option.value)}
                    title={option.value}
                  >
                    {option.label}
                  </Option>
                ))}
              </div>
            ))}
          </Column>
        ))}
      </DropdownContainer>
    </ContextSwitchContainer>
  );
};

export default ContextSwitch;import { FC, useState, useRef, useEffect } from "react";
import styled from "styled-components";

const { NODE_ENV } = process.env;

const ContextSwitchContainer = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  z-index: 99999999999999999999;
`

const ContextSwitchButton = styled.button`
  padding: 6px 10px;
  background: white;
  border: 1px solid #ccc;
  cursor: pointer;
  min-width: 200px;
  text-align: left;
  font-size: 13px;
`

const DropdownContainer = styled.div<{ isOpen: boolean }>`
  display: ${props => props.isOpen ? 'flex' : 'none'};
  position: absolute;
  bottom: 100%;
  right: 0;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 8px 16px 16px;
  gap: 16px;
  max-width: 800px;
  height: 600px;
  max-height: calc(100vh - 100px);
  box-shadow: 0 -2px 10px rgba(0,0,0,0.1);
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 180px;
  max-width: 240px;
  overflow-y: auto;
  max-height: 600px;
  
  > div {
    margin-bottom: 16px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
  
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
    
    &:hover {
      background: #ccc;
    }
  }
`

const GroupLabel = styled.div`
  font-weight: 600;
  padding: 4px 8px;
  color: #666;
  font-size: 13px;
  position: sticky;
  top: 0;
  background: rgba(255, 255, 255, 0.98);
  border-bottom: 1px solid #eee;
  margin-bottom: 4px;
  z-index: 1;
`

const Option = styled.div<{ isSelected: boolean }>`
  padding: 4px 8px;
  cursor: pointer;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: ${props => props.isSelected ? '#f0f0f0' : 'transparent'};
  
  &:hover {
    background: ${props => props.isSelected ? '#e8e8e8' : '#f5f5f5'};
  }

  & + & {
    margin-top: 1px;
  }
`

interface Option {
  value: string;
  label: string;
}

interface Group {
  label: string;
  options: Option[];
}

interface Column {
  groups: Group[];
}

export const CONFIG: Column[] = [
  {
    groups: [
      {
        label: 'Main',
        options: [
          { value: '', label: '--default--' },
          { value: 'deziiign/main', label: 'deziiign.com' },
          { value: 'deziiign/hsedesign', label: 'hsedesign.ru' },
          { value: 'deziiign/mediiia', label: 'mediiia.com' },
          { value: 'deziiign/brnd', label: 'brnd.ru' },
          { value: 'deziiign/ageytomesh', label: 'ageytomesh.com' },
          { value: 'deziiign/superpuper', label: 'superpuper.games' },
        ]
      },
      {
        label: 'HSE',
        options: [
          { value: 'deziiign/hseanimation', label: 'hseanimation.ru' },
          { value: 'deziiign/hsecolors', label: 'hsecolors.com' },
          { value: 'deziiign/hsecreative', label: 'hsecreative.ru' },
          { value: 'deziiign/hsehh', label: 'hsehh.com' },
          { value: 'deziiign/online', label: 'hsedesign.online' },
          { value: 'deziiign/hsespace', label: 'hse.space' },
          { value: 'deziiign/hsestart', label: 'start.hsedesign.com' },
        ]
      }
    ]
  },
  {
    groups: [
      {
        label: 'LMS',
        options: [
          { value: 'deziiign/lmsmediiia', label: 'education.mediiia.com' },
          { value: 'deziiign/lmshse', label: 'lms.hsedesign.com' },
          { value: 'deziiign/lmshsecreative', label: 'lms.hsecreative.ru' },
        ]
      },
      {
        label: 'Mediiia',
        options: [
          { value: 'deziiign/automediiia', label: 'automediiia.com' },
          { value: 'deziiign/namesmediiia', label: 'names.mediiia.com' },
          { value: 'deziiign/naturemediiia', label: 'naturemediiia.com' },
          { value: 'deziiign/urbanmediiia', label: 'urban.deziiign.com' },
        ]
      },
      {
        label: 'Pro',
        options: [
          { value: 'deziiign/pro', label: 'pro.deziiign.com' },
          { value: 'deziiign/prohse', label: 'pro.hsedesign.com' },
        ]
      },
      {
        label: 'Geograffee',
        options: [
          { value: 'geograffee/academy', label: 'creativecity.academy' },
          { value: 'geograffee/dafes', label: 'dafes.net' },
          { value: 'geograffee/main', label: 'geograffee.com' },
        ]
      }
    ]
  },
  {
    groups: [
      {
        label: 'Competitions',
        options: [
          { value: 'deziiign/awards', label: 'awards.portfolio365.ru' },
          { value: 'deziiign/kiiids', label: 'family.kiiids.art' },
          { value: 'competition', label: 'competition.deziiign.com' },
          { value: 'deziiign/damuseum', label: 'contest.damuseum.ru' },
          { value: 'deziiign/greenaward', label: 'green-award.ru' },
        ]
      },
      {
        label: 'Books',
        options: [
          { value: 'deziiign/books', label: 'books.deziiign.com' },
          { value: 'deziiign/booksgallllery', label: 'books.gallllery.com' },
        ]
      },
      {
        label: 'Other',
        options: [
          { value: 'deziiign/monalisatravels', label: 'mona-lisa-travels.com' },
          { value: 'deziiign/alshibaya', label: 'alshibaya.com' },
          { value: 'deziiign/lab', label: 'lab.deziiign.com' },
          { value: 'deziiign/adcrdafesnet', label: 'adcr.dafes.net' },
          { value: 'deziiign/cgrave', label: 'cgrave.ru' },
          { value: 'deziiign/continuumsite', label: 'continuum.site' },
          { value: 'deziiign/school', label: 'designschool.am' },
          { value: 'deziiign/dvadesign', label: 'dva.design' },
          { value: 'deziiign/exams', label: 'exams2025.hsedesign.com' },
          { value: 'deziiign/fashion', label: 'fashion.deziiign.com' },
          { value: 'deziiign/galllleryart', label: 'gallllery.art' },
          { value: 'deziiign/game', label: 'game.deziiign.com' },
          { value: 'deziiign/iqmedia', label: 'iq-media.ru' },
          { value: 'deziiign/lpudesign', label: 'lpudesign.com' },
          { value: 'deziiign/onlines', label: 'onlinesdesign.com' },
        ]
      }
    ]
  }
];

const ContextSwitch: FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(localStorage.getItem('current-app') || '');
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  if (NODE_ENV !== 'development') {
    return null;
  }

  const handleSelect = (value: string) => {
    setSelectedValue(value);
    setIsOpen(false);
    if (!value) {
      localStorage.removeItem('current-app');
    } else {
      localStorage.setItem('current-app', value);
    }
    window.location.reload();
  };

  return (
    <ContextSwitchContainer ref={containerRef}>
      <ContextSwitchButton onClick={() => setIsOpen(!isOpen)}>
        {selectedValue || '--default--'}
      </ContextSwitchButton>
      <DropdownContainer isOpen={isOpen}>
        {CONFIG.map((column, columnIndex) => (
          <Column key={columnIndex}>
            {column.groups.map(group => (
              <div key={group.label}>
                <GroupLabel>{group.label}</GroupLabel>
                {group.options.map(option => (
                  <Option
                    key={option.value}
                    isSelected={selectedValue === option.value}
                    onClick={() => handleSelect(option.value)}
                    title={option.value}
                  >
                    {option.label}
                  </Option>
                ))}
              </div>
            ))}
          </Column>
        ))}
      </DropdownContainer>
    </ContextSwitchContainer>
  );
};

export default ContextSwitch;